<template>
  <event-list type="ficha" />
</template>

<script>
import EventList from '@/components/EventList'

export default {
  name: 'Fichas',
  components: {
    EventList
  }
}
</script>
